<form [formGroup]="basicSettings" (ngSubmit)="submitBasicSettings()">
  <div class="row">
    <div class="col-md-4">
      <label for="userCode">
        {{'_General_User_Code_Text_' | translate }}
        <span tabindex="-1" class="required-field">*</span>
      </label>
      <input id="userCode" class="form-control" formControlName="userCode" type="text" maxlength="50"
        (focusout)="onFocusOutUserCode()" (keyup)="onChangeUserCode()" app-filter
        pattern="^((?=[^<>& ])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$"
        [attr.disabled]="editingUserId === loggedUserId ? 'true' : null">

      <div *ngIf="isUserCodeRequired(userCode)">
        <div class="cc-validation" *ngIf="userCode?.errors?.required">
          {{'_User_User_Settings_User_Code_Required_Validation_Text_' | translate }}
        </div>
      </div>

      <div *ngIf="isUserCodeAlreadyInUse(userCode)">
        <div class="cc-validation" *ngIf="userCodeAlreadyUsed">
          {{'_User_User_Settings_User_Code_Already_Using_Validation_Text_' | translate }}
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <label for="firstName">
        {{'_General_User_First_Name_Text_' | translate }}
        <span tabindex="-1" class="required-field">*</span>
      </label>
      <input id="firstName" class="form-control" formControlName="firstName" type="text" maxlength="50" app-no-lead-ws
        app-filter pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$">

      <div *ngIf="isFirstNameRequired(firstName)">
        <div class="cc-validation" *ngIf="firstName?.errors?.required">
          {{'_General_User_First_Name_Required_Text_' | translate }}
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <label for="lastName">
         {{'_General_User_Last_Name_Text_' | translate }}
        <span tabindex="-1" class="required-field">*</span>
      </label>
      <input id="lastName" class="form-control" formControlName="lastName" type="text" maxlength="50" app-no-lead-ws
        app-filter pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$">

      <div *ngIf="isLastNameRequired(lastName)">
        <div class="cc-validation" *ngIf="lastName?.errors?.required">
          {{'_General_User_Last_Name_Required_Text_' | translate }}
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <label for="userName">
        {{'_General_Username_Text_' | translate }}
        <span tabindex="-1" class="required-field">*</span>
      </label>
      <input id="userName" class="form-control" formControlName="userName" type="text" maxlength="256"
        (focusout)="onFocusOutUserName()" (keyup)="onChangeUserName()"
        [attr.disabled]="editingUserId === loggedUserId ? 'true' : null" app-no-lead-ws>

      <div *ngIf="isUsernameRequired(userName)">
        <div class="cc-validation" *ngIf="userName?.errors?.required">
          {{'_User_User_Settings_Username_Required_Validation_Text_' | translate }}
        </div>
      </div>

      <div *ngIf="isInvalidUsername(userName)">
        <div class="cc-validation" *ngIf="userName?.errors?.invalidEmail">
          {{'_User_User_Settings_Username_Invalid_Validation_Text_' | translate }}
        </div>
      </div>

      <div *ngIf="isUsernameAlreadyInUse(userName)">
        <div class="cc-validation" *ngIf="userNameAlreadyUsed">
          {{'_User_User_Settings_Username_Already_Using_Validation_Text_' | translate }}
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <label for="userGroup">
        {{'_General_Permission_Group_Text_' | translate }}
        <span tabindex="-1" class="required-field">*</span>
      </label>
      <select class="cc-select-dropdown form-control" placeholder="Select" (change)="onPermissionGroupChange()"
        id="permissionGroup" formControlName="permissionGroup">
        <option value="">{{'_General_Select_Text_' | translate}}</option>
        <option *ngFor="let permissionGroup of permissionGroupList" [ngValue]="permissionGroup.id">
          {{permissionGroup.name}}
        </option>
      </select>
      <div class="cc-validation" *ngIf="isPermissionGroupRequired(permissionGroup)">
        {{'_User_User_Settings_Permission_Group_Required_Validation_Text_' | translate }}
      </div>
    </div>
    <div class="col-md-4">
      <label for="notificationGroups">
        {{'_General_Notification_Groups_Text_' | translate }}
        <span>
          ({{
          this.basicSettings.get('notificationGroups')?.value?
          this.basicSettings.get('notificationGroups')?.value?.length: 0
          }}) {{'_User_User_Settings_Notification_Groups_Checked_Text_' | translate }}
        </span>
      </label>
      <ng-multiselect-dropdown [ngClass]="'cc-multi-select float-multi'" placeholder="{{'_General_Select_Text_' | translate }}" 
        [settings]="dropdownSettings" [data]="notificationGroupList" formControlName="notificationGroups"
        [(ngModel)]="selectedNotificationGroupList" (onSelect)="onItemSelect($event)"
        (onDeSelect)="onItemSelect($event)" (onSelectAll)="onItemSelect($event)" (onDeSelectAll)="onItemSelect($event)">
      </ng-multiselect-dropdown>
    </div>
    <div class="col-md-4">
      <label for="primaryNotificationEmail">
        {{'_General_Primary_Notification_Email_Text_' | translate }}
        <span tabindex="-1" class="required-field">*</span>
          <ng-template #primaryNotificationEmailTooltip let-anchor>
            <div class="tooltip-content">
              <p>{{'_User_Following_Primary_Emails_Ts_1_Text_' | translate }}</p>
                <ul>
                  <li>{{'_User_Following_Primary_Emails_Ts_2_Text_' | translate }}</li>
                  <li>{{'_User_Following_Primary_Emails_Ts_3_Text_' | translate }}</li>
                  <li *ngIf="isACLicenseEnabled">{{'_User_Following_Primary_Emails_Ts_4_Text_' | translate }}</li>
                  <li *ngIf="isACLicenseEnabled">{{'_User_Following_Primary_Emails_Ts_5_Text_' | translate }}</li>
                  <li *ngIf="isACLicenseEnabled">{{'_User_Following_Primary_Emails_Ts_6_Text_' | translate }}</li>
                  <li>{{'_User_Following_Primary_Emails_Ts_7_Text_' | translate }}</li>
                </ul>
            </div>
          </ng-template>
        <span kendoTooltip [tooltipTemplate]="primaryNotificationEmailTooltip" tooltipClass="kendo-tooltip-formatted" title="" class="fas fa-info-circle ms-1"></span>
      </label>
      <input app-no-lead-ws id="primaryNotificationEmail" class="form-control"
        formControlName="primaryNotificationEmail" type="email" maxlength="256" (keyup)="onChangeUserEmail()"
        (keydown.space)="$event.preventDefault()">
      <div
        *ngIf="isPrimaryNotificationEmailRequired(primaryNotificationEmail)">
        <div class="cc-validation" *ngIf="primaryNotificationEmail?.errors?.required">
          {{'_General_Primary_Notification_Email_Required_Text_' | translate }}
        </div>
      </div>

      <div *ngIf="isPrimaryNotificationEmailInvalid(primaryNotificationEmail)">
        <div class="cc-validation" *ngIf="primaryNotificationEmail?.errors?.invalidEmail">
          {{'_General_Invalid_Primary_Notification_Email_Text_' | translate }}
        </div>
      </div>

      <!-- <div *ngIf="(primaryNotificationEmail.dirty || primaryNotificationEmail.touched)">
        <div class="cc-validation" *ngIf="primaryNotificationEmailAlreadyUsed">
          Primary Notification Email is already in use
        </div>
      </div> -->
    </div>

    <div class="col-md-4">
      <label for="phoneNumber">{{'_General_Phone_Number_Column_Title_' | translate }}</label>
      <input id="phoneNumber" class="form-control" type="text" formControlName="phoneNumber" maxlength="10"
        (focusout)="onFocusOutPhoneNumber()" app-no-lead-ws app-filter pattern="(^(\s*|[0-9]*)$)">
      <div *ngIf="invalidPhoneNumber">
        <div class="cc-validation" *ngIf="invalidPhoneNumber">
          {{'_General_User_Phone_Invalid_Text_' | translate }}
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <label for="preferredLanguage">{{'_General_Preferred_Language_Text_' | translate }}</label>
      <select class="cc-select-dropdown form-control" id="preferredLanguage" formControlName="prefferedLanguage">
        <option *ngFor="let preferredLanguage of prefferedLanguagesAvailable; trackBy: languageTrackBy"
          [ngValue]="preferredLanguage.id">
          {{preferredLanguage.displayValue | translate }}
        </option>

      </select>
    </div>

    <div class="col-md-4">
      <label for="homeLocation">{{'_General_Home_Location_Text_' | translate }}</label>
      <app-location-selector [dispatchStateEvent]="false" (onChange)="onLocationChange($event)" id="homeLocation"
        [isDisableParentClick]="true" [selectedLocationId]="locationId" selectedLocationName="{{locationName}}"
        [isIncludeFloatLocation]="false">
      </app-location-selector>

      <!-- <select class="cc-select-dropdown form-control" id="homeLocation" formControlName="homeLocation">
        <option *ngFor="let location of locationList" [ngValue]="location.id">
          {{location.locationName}}
        </option>
      </select> -->
    </div>
    <div class="col-md-4 checkbox d-flex align-items-center">
      <label>
        <input id="activeUser" formControlName="activeUser" (change)="activeStatusChange()" class="cc-filter-checkbox"
          type="checkbox" kendoCheckBox />
        {{'_General_Active_Text_' | translate }}
      </label>
    </div>
    <div class="col-md-4 checkbox d-flex align-items-center">
      <label>
        <input id="spanishSpeaker" formControlName="spanishSpeaker" class="cc-filter-checkbox" type="checkbox"
          kendoCheckBox />
        {{'_User_User_Settings_Spanish_Speaker_Label_Text_' | translate }}
      </label>
    </div>
    <div class="col-md-4 checkbox">
      <div class="d-flex align-items-center">
        <label>
          <input id="accountLocked" formControlName="accountLocked" class="cc-filter-checkbox" type="checkbox"
            kendoCheckBox (change)="unlockAccount()" />
          {{'_User_User_Settings_Account_Locked_Label_Text_' | translate }}
        </label>
      </div>
      <div class="tab-indent">
        <label>{{'_User_User_Settings_Failed_Login_Attempts_Label_Text_' | translate }}<span class="ms-2">{{failedLoginCount}}</span></label>
        <div class="cc-inline" *ngIf="tenantConfiguration?.localLoginEnalbed">
          <button type="button"
            [disabled]="this.basicSettings.get('accountLocked')?.value == true || editingUserId == 0 || !userloginEnabled || !userActive"
            (click)="sendResetPasswordEmail()" class="btn btn-primary">
            {{'_User_User_Settings_Reset_Password_Label_Text_' | translate }}
          </button>
          <button type="button" (click)="onToggle()" [ngClass]="isResetClicked?'':'disabled'"
            [disabled]="!isResetClicked" class="external-link cc-icon-btn">
            <span class="fas fa-link" title="{{'_General_Copy_Link_Text_' | translate }}"></span>
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-4 checkbox">
      <div class="d-flex align-items-center" *ngIf="isACLicenseEnabled">
        <label>
          <input id="loginEnabled" formControlName="loginEnabled" class="cc-filter-checkbox" type="checkbox"
            kendoCheckBox (change)="loginStatusChange($event)" />
            {{'_User_User_Settings_Login_Enabled_Label_Text_' | translate }}
        </label>
      </div>
      <div [ngClass]="{'tab-indent': isACLicenseEnabled}" *ngIf="userloginEnabled">
        <label>{{'_User_User_Settings_Two_Factor_Authentication_Label_Text_' | translate }}</label>
        <div class="d-flex align-items-center">
          <label>
            <input id="useAuthentication" formControlName="useAuthentication" class="cc-filter-checkbox" type="checkbox"
              kendoCheckBox />
            {{'_User_User_Settings_Use_Authentication_Label_Text_' | translate }}
          </label>
        </div>
        <div class="d-flex align-items-center">

          <label>
            <input id="resetAtNextLogon" formControlName="resetAtNextLogon" class="cc-filter-checkbox" type="checkbox"
              kendoCheckBox />
            {{'_User_User_Settings_Reset_At_Next_Logon_Label_Text_' | translate }}
          </label>
        </div>

      </div>
    </div>
  </div>
  <!-- Button Panel -->
  <div class="cc-btn-panel">
    <button type="button" (click)="cancelClicked()" class="btn btn-secondary">{{'_General_Button_Close_Text_' | translate }}</button>
    <button type="submit"
      [disabled]="isSaveButtonDisabled()"
      class="btn btn-primary">
      {{'_General_Button_Save_Text_' | translate }}
    </button>
    <button type="button"
      [disabled]="isSaveAndContinueButtonDisabled()"
      *ngIf="isSaveAndContinueVisible" (click)="saveUserSynchronous()" class="btn btn-primary">
      {{'_General_Save_Continue_Text_' | translate }}
    </button>
  </div>
</form>

<kendo-dialog id="reset-link-dialog" title="{{'_General_Password_Reset_Link_Text_' | translate }}" *ngIf="show" (close)="close('cancel')" [minWidth]="250"
  [width]="650">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
  <input #userinput type="text" [(ngModel)]="passwordResetLink" [disabled]="true" />
  <kendo-dialog-actions class="cc-btn-panel">
    <button type="button" id="cancel-dialog" class="btn btn-secondary" (click)="close('yes')" primary="true">
      {{'_General_Button_Cancel_Text_' | translate }}
    </button>
    <button type="button" id="copy-link-dialog" class="btn btn-primary" (click)="copyInputMessage(userinput.value)"
      value="click to copy">
      {{'_General_Copy_Link_Text_' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
